<section [ngClass]="payload?.cssClass">
    <div class="ispm-dynamic-form-viewer-progress" *ngIf="showProgressBar">
        <span *ngFor="let formPayload of payload.formsPayload; let i = index"
              [class.active]="submitted[i]"
              [ngClass]="{'ispm-dynamic-form-status-indicator': true}">
        </span>
    </div>
    <div class="ispm-indicator-information" *ngIf="showIndicators">
        <span class="ispm-indicator-information-item">
            <span class="ispm-acr-mandatory-fields-indicator icon__circle"></span>ACR Registry Submission Mandatory
        </span>
        <span class="ispm-indicator-information-item">
            <span class="ispm-mandatory-fields-indicator icon__Asterisk"></span>Mandatory
        </span>
      <span class="ispm-indicator-information-item" *ngIf="isWorkflowDataInProgress">
            <span class="ispm-mandatory-fields-indicator icon__Warning"></span>Workflow Specific Eligibility Data Cloning In Progress...
        </span>

    </div>
    <section class="ispm-forms-composer-viewer"
             *ngIf="!isWorkflowFrozen"
             [ngClass]="{'ispm-forms-composer-viewer-with-actions': isEditMode && payload.formsPayload && payload.formsPayload.length > 0 && payload?.controls,
                        'ispm-forms-composer-viewer-without-actions': !isEditMode || !payload?.controls}">
        <gen-dynamic-form *ngFor="let formPayload of payload.formsPayload; let i = index"
                          [popupMode]="formPayload.popupMode || true"
                          [formConfig]="formPayload.formConfig"
                          [formName]="formPayload.formId"
                          [formData]="formPayload.formData"
                          [editMode]="isEditMode || true"
                          [overrides]="false"
                          [formVertical]="formPayload.formVertical"
                          [disabled]="!isEditMode || false"
                          [requiredMessage]="''"
                          (formChange)="updateFormData($event, i)"
                          [mapAllProperties]="true"
                          [submitted]="buttonSubmitted"
                          [resetForm]="resetFrom"
                          [notifyDefaultValueInit]="true"
                          (validateChange)="updateValidate($event, i)"
                          [title]="formPayload.title"
                          [subTitle]="formPayload.subTitle"
                          [ngClass]="formPayload.cssClass"
                          (dataRecieved)="dataRecievedEvent($event, i)"
        ></gen-dynamic-form>
    </section>

  <section class="ispm-forms-composer-viewer freeze"
           *ngIf="isWorkflowFrozen"
           [ngClass]="{'ispm-forms-composer-viewer-with-actions': isEditMode && payload.formPayloadFrozen && payload.formPayloadFrozen.length > 0 && payload?.controls,
                        'ispm-forms-composer-viewer-without-actions': !isEditMode || !payload?.controls}">
    <gen-dynamic-form *ngFor="let freezeFormPayload of payload.formPayloadFrozen; let i = index"
                      [popupMode]="freezeFormPayload.popupMode || true"
                      [formConfig]="freezeFormPayload.formConfig"
                      [formName]="freezeFormPayload.formId"
                      [formData]="freezeFormPayload.formData"
                      [editMode]="isEditMode || true"
                      [overrides]="false"
                      [formVertical]="freezeFormPayload.formVertical"
                      [disabled]="!isEditMode || false"
                      [requiredMessage]="''"
                      (formChange)="updateFormData($event, i)"
                      [mapAllProperties]="true"
                      [submitted]="buttonSubmitted"
                      [resetForm]="resetFrom"
                      [notifyDefaultValueInit]="true"
                      (validateChange)="updateValidate($event, i)"
                      [title]="freezeFormPayload.title"
                      [subTitle]="freezeFormPayload.subTitle"
                      [ngClass]="freezeFormPayload.cssClass"
                      (dataRecieved)="dataRecievedEvent($event, i)"
    ></gen-dynamic-form>
  </section>

    <section class="actions-container"
             *ngIf="isEditMode && payload.formsPayload && payload.formsPayload.length > 0 && payload?.controls && !createMode">
        <gen-button
                *ngFor="let control of payload.controls"
                [text]="control.name"
                [type]="control.btnType? control.btnType : 'primary'"
                [iconClass]="control.iconClass"
                (click)="buttonClick(control.type)">
        </gen-button>
    </section>
    <section class="actions-container-edit"
             *ngIf="enableEditButton && !isEditMode && !createMode">
        <gen-button
                [text]="'Edit'"
                [type]="'primary'"
                (click)="buttonClick('edit')">
        </gen-button>
    </section>
    <section class="actions-container-edit"
             *ngIf="isEditMode && createMode">
        <gen-button
                [text]="'Save'"
                [type]="'primary'"
                (click)="buttonClick('submit')">
        </gen-button>
    </section>
</section>
<gen-overlay-loader *ngIf="!isdataRecieved" [loaderType] = "'SKELETON-PLAIN'"  [showOverlay]="false"></gen-overlay-loader>
